export const bagSizes = [
  { size: "1kg", amount: 1000 },
  { size: "500g", amount: 500 },
  { size: "250g", amount: 250 },
];
export const grind = [
  "Whole Beans",
  "Chemex",
  "Commercial",
  "Domestic",
  "Filter",
  "Plunger",
  "Stovetop",
  "Turkish",
  "V60",
];
